import React, { useEffect, useState, useCallback, useContext, useMemo } from 'react';
import Head from 'next/head';
import Router, { useRouter } from 'next/router';
import get from 'lodash/get';
import filter from 'lodash/filter';
import Cookies from 'cookies';
import CSSTransition from 'react-transition-group/CSSTransition';
import pageDisable from '../../helpers/pageDisableHelper';
import getDefaultTab from '../../helpers/getDefaultTab';
import axios from '../../utils/ajax';
import Header from '../../components/Header';
import Product from '../../components/Product';
import InlineLoader from '../../components/InlineLoader';

import * as COOKIE_VARIABLES from '../../constants/cookieVariables';
import * as SegmentSource from '../../constants/segmentSource';
import { ASAP, ASAP_AND_SCHEDULE, SCHEDULE } from '../../constants/deliveryType';
import { DEFAULT_CATEGORY_MENU, DEFAULT_LOCATION, DEFAULT_ZIPCODE } from '../../constants/default';
import { shop } from '../../constants/breadcrumbPaths';
import notificationTypes from '../../constants/modalNotificationConst';

import categoriesHelper from '../../helpers/categoriesHelper';
import generateFilters from '../../helpers/generateFilters';
import * as WEBSITES from '../../constants/website';
import { ALLOW_PRODUCT_COMPARE } from '../../constants/verificationConst';
import FloatingCompareButton from '../../components/FloatingCompareButton';

import Banner from '../../components/BannerNew';
import AddressBox from '../../components/AddressBox';
import CategoryMenu from '../../components/DTC/CategoryMenu';
import HraderDeliveryAddress from '../../components/HraderDeliveryAddress';
import DeliveryTabs from '../../components/DTC/DeliveryTabs';
import Filters from '../../components/DTC/Filter';
import Page404 from '../404';
import HraderDeliveryAddressNew from '../../components/DTC/bento/HraderDeliveryAddress'

import {
  useAsapProductsCategory,
  useScheduleProductsCategory,
  useBannerImages,
  useFullCategoryList,
  useFilters,
  useProductCount
} from '../../hooks/Shop';
import StorageService from '../../services/storageService';

// import appConfig from '../../appConfig';
import useSegment from '../../hooks/segment';
import appContext from '../../Context/appContext';
import { useDeliveryDetails } from '../../hooks/app';
import RemainingTime from '../../components/RemainingTime';
import BreadCrumbs from '../../components/BreadCrumbs';
import FreightLimit from '../../components/FreightLimit';
import SelectedFiltersList from '../../components/SelectedFiltersList';
import NoProductAvailable from '../../components/no-products-available';
import FloatingFilterButton from '../../components/FloatingFilterButton';
import grassdoorRedirects from '../../constants/grassdoorRedirects';
import getHost from '../../helpers/gethost';
import { matchFilter } from '../../helpers/filterHelper';
import MiniTabs from '../../components/DTC/grassdoor/MiniTabs';
import DesktopFilter from '../../components/DesktopFilter';
import isMobile from '../../helpers/isMobile';
import SearchTabs from '../../components/DTC/grassdoor/SearchTabs';
import FixedBottomBar from '../../components/FixedBottomBar';
import { isNewHomePageApplicable } from '../../constants/feature';
import SearchButton from '../../components/searchModule/SearchButton';
import { updateFilterList } from '../../hooks/common';
import { BannerSlider } from '../../components/BannerSlider';
import { useDispatch, useSelector } from 'react-redux';
import { increaseURLstack, pushIfNotPresent } from '../../redux/slices/modalSlice';
import { setUrlBeforeCompare, updateSelectedTab } from '../../redux/slices/userSlice';
import DeliveryTypeToggle from '../../components/DeliveryTypeToggle';
import ScrollToTop from '../../components/ScrollToTop';
import { withConfig } from '../../lib/withConfig';
import { useConfigData } from '../../Context/ConfigProvider';
import BannerCustom from '../../components/BannerCustom';
import fetchServerResponse from '../../helpers/serverHelper';
import DeliveryTiming from '../../components/DeliveryTiming';
import DeliveryTimingSchedule from '../../components/DeliveryTimingSchedule';

const canonicalHref = `https://${getHost()}/shop/`; //same used for og:url

let tabSwitched = 0
const ViewAllProducts = ({
  asapProductsCategoryInitial,
  scheduleProductsCategoryInitial,
  filterList,
  error,
  bannerData: initialBannerData,
  categoryDetails,
  noIndex,
  asapCount: initialAsapCount,
  scheduleCount: initialScheduleCount,
  asapProductsCategoryDetails: initialAsapProductsCategoryDetails,
  scheduleProductsCategoryDetails: initialScheduleProductsCategoryDetails,
  fullCategoriesList: initialFullCategoriesList,
  id
}) => {
  const {
    state: {
      // initialHistoryLength,
      // user: { couponData, userSelectedTab },
      shop: { shopFilters },
      // seoData = {},
      // miniTabs,
      // compare,
      // searchTabs
    },
    dispatch
  } = useContext(appContext);
  const appConfig = useConfigData();
  const { seoData = {}, miniTabs } = useSelector(state => state.other) || {}
  const compare = useSelector(state => state.compare)
  const { couponData, searchTabs, initialHistoryLength, isLoggedIn } = useSelector(state => state.user)
  const dispatchRedux = useDispatch()

  const {
    data: { asapEnabled = true, scheduleEnabled, unified_menu: unifiedMenu, asapStartTime, asapEndTime, lastSlotCutOff }
  } = useDeliveryDetails();

  const router = useRouter();
  const {
    query: { slug, tab: routerTab },
    pathname
  } = router;
  const tab = routerTab || getDefaultTab({ asapStartTime, asapEndTime, lastSlotCutOff, asapEnabled });
  const { data: filterShopList = [], isValidating: isValidatingFilters } = useFilters({ param: 'shop_slug', slug });
  const { data: { asapFilterData, scheduleFilterData } } = useProductCount({ slug })

  const [filters, setFilters] = useState(filterShopList || filterList);
  const [isFilterPopupVisible, toggleFilterPopup] = useState(false);
  const [isSolid, setIsSolid] = useState(false);

  useEffect(() => {
    // if (!tabSwitched) {
    //   tabSwitched = 1;
    //   return
    // }
    // if (tabSwitched) setFilters(filters, tab === ASAP ? asapFilterData : scheduleFilterData)
    setFilters(updateFilterList(filters, tab === ASAP ? asapFilterData : scheduleFilterData));
  }, [tab])
  useEffect(() => {
    if (!isValidatingFilters && filters && filterShopList) {
      const newFilters = matchFilter(filters, filterShopList);
      // setFilters(newFilters);
      setFilters(updateFilterList(newFilters, tab === ASAP ? asapFilterData : scheduleFilterData));
    }
  }, [isValidatingFilters, scheduleFilterData, asapFilterData]);

  let isShopPage = true;

  const {
    data: { currentCategory: currentAsapCategory, asapCount, categoryDetails: asapCategoryDetails },
    isLoading: isLoadingAsap,
    isValidating: isValidatingAsap
  } = useAsapProductsCategory({
    slug,
    asapProductsCategoryInitial,
    initialAsapCount,
    initialAsapProductsCategoryDetails,
    filters,
    isShopPage
  });

  const {
    data: { currentCategory: currentScheduledCategory, scheduleCount, categoryDetails: scheduleCategoryDetails },
    isLoading: isLoadingSchedule,
    isValidating: isValidatingSchedule
  } = useScheduleProductsCategory({
    slug,
    scheduleProductsCategoryInitial,
    initialScheduleCount,
    initialScheduleProductsCategoryDetails,
    filters
  });

  const { data: bannerData } = useBannerImages({ initialBannerData });
  const { data: fullCategoryList = DEFAULT_CATEGORY_MENU } = useFullCategoryList({ initialFullCategoriesList });
  const isLoading = tab === ASAP ? isLoadingAsap : isLoadingSchedule;
  const currentCategory = useMemo(() => {
    if (isLoading) return tab === ASAP ? asapProductsCategoryInitial : scheduleProductsCategoryInitial;
    return tab === ASAP ? currentAsapCategory : currentScheduledCategory;
  }, [tab, currentAsapCategory, currentScheduledCategory, isLoading]);
  const isValidating = tab === ASAP ? isValidatingAsap : isValidatingSchedule;
  const fetching = isLoading || isValidating;
  const { site_info: siteInfo = {} } = seoData;
  const {
    category_meta_title: categoryMetaTitle = `Shop | ${siteInfo.meta_title_description || appConfig.META_TITLE_DESCRIPTION}`,
    category_meta_description: categoryMetaDescription = appConfig.APP_NAME
  } = currentCategory || {};

  const { og_title: ogTitle, og_description: ogDescription, og_image: ogImage, schema: category_schema } = categoryDetails || {};

  const handleScroll = useCallback(() => {
    if (window.scrollY > 150) {
      if (!isSolid) {
        setIsSolid(true);
      }
    } else if (isSolid) {
      setIsSolid(false);
    }
  }, [isSolid]);

  const setTab = useCallback(
    newTab => {
      if (tab !== newTab) {
        const href = `/shop/${slug}?tab=${newTab}`;
        // const as = '/shop/[slug]';
        router.replace(href, undefined, { shallow: true });
      }
    },
    [tab, router, slug]
  );

  useEffect(() => {
    //performance: remove event listener
    document.addEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const { trackPage, trackEvent } = useSegment();
  // Segment Data Layer
  useEffect(() => {
    if (currentCategory && process.browser) {
      trackPage('Category Page');
    }
  }, []);

  useEffect(() => {
    dispatch({ type: 'setFilters', payload: { shopFilters: filters } });
  }, [filters]);

  useEffect(() => {
    if (currentCategory && process.browser) {
      const { discount_code: discountCode } = couponData;

      const origin = window.location.origin;
      const products = [];
      // eslint-disable-next-line no-unused-expressions
      currentCategory &&
        currentCategory.products &&
        currentCategory.products.forEach((item, index) => {
          products.push({
            product_id: item.product_details_id,
            sku: item.bundle_id ? item.bundle_id : item.master_product_id,
            name: item.product_name,
            strain_type: item.product_strain_type_name,
            price: item.price,
            original_price: item.price_without_deal,
            position: index,
            category_row_position: index,
            product_attributes: Array.isArray(item.product_attributes_second) ? item.product_attributes_second.join('/') : '',
            brand: Array.isArray(item.brand_names) ? item.brand_names.join('/') : item.brand_slug,
            variant: item.product_unit,
            quantity: 1,
            coupon: discountCode,
            category_frontend: item.category_name,
            category: item.full_shop_category_name,
            url: `${origin}/product/${item.slug}`,
            image_url: item.product_image
          });
        });
      const zoneName = StorageService.getZoneLocalStorage();
      trackEvent('Product List Viewed', {
        list_id: `${tab == ASAP ? 'ASAP' : 'Schedule'} List - Category`,
        category: currentCategory && currentCategory.length && currentCategory[0].category_name,
        products,
        zone_name: zoneName
      }, !isLoggedIn);
    }
  }, []);

  const handleGoBack = () => {
    if (window.history.length > initialHistoryLength) {
      Router.back();
    } else {
      Router.push('/');
    }
  };

  const handleFloatingButtonClick = () => {
    const url = '/compare';
    dispatchRedux(pushIfNotPresent({ type: notificationTypes.comparePopup, data: { source: "Floating widget" } }))
    dispatchRedux(increaseURLstack())
    // dispatch({ type: 'setUrlBeforeCompare', payload: { urlBeforeCompare: window.location.href } });
    dispatchRedux(setUrlBeforeCompare({ urlBeforeCompare: window.location.href }))
    window.history.replaceState({ ...window.history.state, as: url, url }, '', url);
  };

  if (error) {
    return <Page404 />;
  }

  let filterApplied = false;
  if (filters) {
    filters.forEach(element => {
      if (
        element.type === 'sort_key' &&
        (!element.values[0].checked || (element.values[0].checked && element.values[0]?.intended))
      ) {
        filterApplied = true;
      }
      if (element.type === 'search' && filter(element.values, { checked: true }).length > 0) {
        filterApplied = true;
      }
    });
  }

  return (
    <div key={routerTab}>
      <Head>
        <title>{categoryMetaTitle}</title>
        <meta name="description" content={categoryMetaDescription} />
        <meta property="og:title" content={ogTitle || appConfig.META_TITLE} />
        <meta property="og:description" content={ogDescription || appConfig.META_TITLE_DESCRIPTION} />
        <meta property="og:image" content={ogImage || appConfig.META_IMAGE} />
        {noIndex && <meta name="robots" content="noindex" />}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${canonicalHref}${id}`} />
        <link rel="canonical" href={`${canonicalHref}${id}`} />
        {category_schema ? <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: category_schema }} /> : null}
      </Head>
      <Header
        hasShadow={isSolid}
        hasWhiteBg={isSolid}
        backPath
        toPath="/shop"
        onClickFilter={() => toggleFilterPopup(true)}
        centerComponent={<HraderDeliveryAddress hideOnLarge />}
        showFilter={!isNewHomePageApplicable}
        filterApplied={filterApplied}
        currentTab={tab}
        asapProductsCount={asapCount || 0}
        scheduledProductsCount={scheduleCount || 0}
        setTab={setTab}
        search={false}
        showUserInfo={isNewHomePageApplicable}
        showDeliverySpecificMessage={isNewHomePageApplicable}
        showLogin={!isNewHomePageApplicable}
        help={isNewHomePageApplicable}

      />
      {isNewHomePageApplicable ? <SearchTabs
        enabled={searchTabs}
        fullCategoryList={fullCategoryList}
        setTab={setTab}
        currentTab={tab}
        defaultSearchTab="schedule"
        backPath
        toPath="/shop"

      >
        <SelectedFiltersList filtersList={shopFilters} filtersType="shopFilter" />
      </SearchTabs> :
        <MiniTabs
          enabled={miniTabs}
          fullCategoryList={fullCategoryList}
          currentTab={tab}
          asapProductsCount={asapCount}
          scheduledProductsCount={scheduleCount}
          asapEnabled={asapEnabled}
          scheduleEnabled={scheduleEnabled}
          setTab={setTab}
          className="category-page-tabs"
        >
          <SelectedFiltersList filtersList={shopFilters} filtersType="shopFilter" />
        </MiniTabs>
      }
      <ProductCategory
        isLoading={isLoading}
        currentAsapCategory={currentAsapCategory}
        isValidating={isValidating}
        currentCategory={currentCategory}
        fetching={fetching}
        bannerData={bannerData}
        categoryDetails={tab === ASAP ? asapCategoryDetails || initialAsapProductsCategoryDetails : scheduleCategoryDetails || initialScheduleProductsCategoryDetails}
        setTab={setTab}
        asapCount={asapCount}
        scheduleCount={scheduleCount}
        filters={filters}
        setFilters={(list) => setFilters(updateFilterList(list, tab === ASAP ? asapFilterData : scheduleFilterData))}
        shopFilters={shopFilters}
        filterList={filterList}
        filterApplied={filterApplied}
        isFilterPopupVisible={isFilterPopupVisible}
        toggleFilterPopup={toggleFilterPopup}
        fullCategoryList={fullCategoryList}
        handleGoBack={handleGoBack}
        isSolid={isSolid}
        dispatch={dispatch}
        compare={compare}
        handleFloatingButtonClick={handleFloatingButtonClick}
        unifiedMenu={unifiedMenu}
        key={routerTab + slug}
      />
    </div>
  );
};

const ProductCategory = ({
  isLoading,
  currentAsapCategory,
  isValidating,
  currentCategory,
  fetching,
  bannerData,
  categoryDetails,
  setTab,
  asapCount,
  scheduleCount,
  filters,
  filterList,
  setFilters,
  shopFilters,
  filterApplied,
  isFilterPopupVisible,
  toggleFilterPopup,
  fullCategoryList,
  handleGoBack,
  isSolid,
  dispatch,
  compare,
  handleFloatingButtonClick,
  hideFreightLimit,
  unifiedMenu,
  key
}) => {
  const {
    data: { asapEnabled = true, scheduleEnabled, asapStartTime, asapEndTime, lastSlotCutOff },
    isLoading: isAddressLoading
  } = useDeliveryDetails();

  const dispatchRedux = useDispatch()
  const appConfig = useConfigData();
  const router = useRouter();
  // const { scrollDirectionTop } = useScrollTop()
  const {
    query: { tab: routerTab, slug }
  } = router;

  const tab = routerTab || getDefaultTab({ asapStartTime, asapEndTime, lastSlotCutOff });
  const [displayFreightBanner, setDisplayFreightBanner] = useState(true)

  let currentTab = tab;

  if (!asapEnabled) {
    currentTab = SCHEDULE;
  } else if (!scheduleEnabled) {
    currentTab = ASAP;
  }

  let bothTypeSchedule = false;
  if (scheduleEnabled && asapEnabled) {
    bothTypeSchedule = true;
  }

  const descriptionText = categoryDetails && categoryDetails.h2_tag ? categoryDetails.h2_tag : null;
  const headerText = categoryDetails && categoryDetails.h1_tag ? categoryDetails.h1_tag : null;

  const { tab: pathName } = router.query;
  useEffect(() => {
    if (currentTab == ASAP && pathName == SCHEDULE && !bothTypeSchedule && !isAddressLoading) {
      router.push(`/shop/${slug}?tab=${ASAP}`);
    } else if (currentTab == SCHEDULE && pathName == ASAP && !bothTypeSchedule && !isAddressLoading) {
      router.push(`/shop/${slug}?tab=${SCHEDULE}`);
    }
  }, [pathName, currentTab, bothTypeSchedule, isAddressLoading]);

  const customBanner = categoryDetails && categoryDetails.banner_images || {};


  const handleApplyFilters = newFilters => {
    setListLoading(true);
    if (!newFilters) {
      setFilters(filterList);
    } else {
      setFilters(newFilters);
    }
    if (!isLoading) setListLoading(false);
  };

  const breadcrumbPath = [
    ...shop,
    ...[
      {
        icon: '',
        title: currentCategory && currentCategory.category_name ? currentCategory.category_name : '',
        path: ''
      }
    ]
  ];

  const [listLoading, setListLoading] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      return setListLoading(false);
    }
  }, [isLoading]);

  useEffect(() => {
    let timeout;
    if (listLoading && !isLoading) {
      timeout = setTimeout(() => setListLoading(false), 1000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [listLoading, isLoading]);

  return (
    <>
      <div className={`category-product shop-full-menu`}>

        <div className='mobile-toggle px-2'>
          <div>
            <div className='flex justify-center w-full items-center gap-4'>
              <div id="search-category-wrapper" className={`search-category-wrapper mt-2 flex-grow max-w-[780px]`}>
                <div className={`searchBox`}>
                  <div className="new-search-component">
                    <div className="input-group searchBar">
                      <div className="input-group searchBar">
                        <HraderDeliveryAddressNew />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DeliveryTypeToggle
            currentTab={tab}
            setTab={setTab}
            isAsapDisabled={false}
            isScheduleDisabled={!scheduleEnabled}
            hideToggle={!asapEnabled || !scheduleEnabled}
            displayForMobile
          />
          <div className='text-center block md:hidden  mt-[12px] md:mt-0'>
            {
              currentTab === ASAP ?
                <DeliveryTiming currentTab={"asap"} onlyText fullText />
                :
                <DeliveryTimingSchedule onlyText currentTab={currentTab} fullText />
            }
          </div>
        </div>

        {fullCategoryList && <CategoryMenu className=" mt-4 " fullCategoryList={fullCategoryList} />}

        {![WEBSITES.GRASSDOOR].includes(process.env.NEXT_PUBLIC_APP) && (
          [WEBSITES.GANJAGODDESS, WEBSITES.BENTO].includes(process.env.NEXT_PUBLIC_APP) ?
            <BannerSlider customBanner={customBanner} bannerData={categoryDetails?.banner_images} />
            :
            // <Banner customBanner={customBanner} bannerData={bannerData} loading={isLoading}>
            //   <AddressBox />
            // </Banner>
            <BannerCustom bannerData={categoryDetails?.banner_images} currentTab={tab} />
        )}
        {isNewHomePageApplicable ? <SearchButton toggleFilterPopup={toggleFilterPopup} hideFilter /> : null}
        {/* <CategoryMenu className="full-width" /> */}
        <div className="container">
          {/* <Htags className="pl-0" /> */}
          <div className="">
            <div className=" one-rem-mb   ">
              <div className="filter-product-page ">
                <div className="g-right-sec ">
                  {isNewHomePageApplicable ? null : <>
                    <DeliveryTabs
                      asapProductsCount={asapCount}
                      className="category-page-tabs"
                      scheduledProductsCount={scheduleCount}
                      asapEnabled={asapEnabled}
                      scheduleEnabled={scheduleEnabled}
                      setTab={setTab}
                      currentTab={tab}
                    />

                    <FreightLimit currentTab={tab} />

                    <RemainingTime setTab={setTab} currentTab={tab} />
                  </>}
                  {/* {appConfig.isGrassdoor || process.env.NEXT_PUBLIC_APP === WEBSITES.BENTO ? ( */}
                  {
                    isMobile() ? isNewHomePageApplicable ? null : (
                      <FloatingFilterButton
                        filters={filters}
                        toggleFilterPopup={toggleFilterPopup}
                        filterApplied={filterApplied}
                        isSolid={isSolid}
                      />
                    ) : (
                      <DesktopFilter
                        filterList={filters}
                        currentTab={tab}
                        applyFilters={filters => {
                          setListLoading(true);
                          if (!filters) {
                            setFilters(filterList);
                          } else {
                            setFilters(filters);
                          }
                        }}
                        cancelFilters={() => toggleFilterPopup(true)}
                        deviceType="desktop"
                        isFilterApplied={filterApplied}
                        shadowHeight={120}
                      >
                        {' '}
                        <SelectedFiltersList setListLoading={setListLoading} filtersList={shopFilters} filtersType="shopFilters" className="sticky-filter-list" />
                      </DesktopFilter>
                    )
                  }
                  {/* ) : null} */}

                  {/* <SelectedFiltersList setListLoading={setListLoading} filtersList={shopFilters} filtersType="shopFilters" className="d-lg-none" /> */}

                  {/* Do not remove */}
                  <div id="list-top" />

                  {breadcrumbPath && !isNewHomePageApplicable ? <BreadCrumbs paths={breadcrumbPath} /> : null}

                  {
                    listLoading && (
                      <div className="text-center my-2">
                        <InlineLoader positionRelative className="big" />
                      </div>
                    )
                  }

                  <div style={{ minHeight: '100vh' }}>
                    <div className="text-center">
                      {/* <h4 className="bold schedule-title">ASAP Delivery Menu</h4> */}
                      {filters?.length > 0 ? (
                        <div
                          className={
                            appConfig.isGrassdoor
                              ? 'sidebarItemStyle filter-btn dig-bud my-4 d-none'
                              : 'sidebarItemStyle ml-2 filter-btn fab d-lg-none hide-for-kiva d-none'
                          }
                          role="presentation"
                          onClick={() => toggleFilterPopup(true)}
                        >
                          <span className="icon icon-filter" />

                          <span className="text">
                            &nbsp;
                            {appConfig.isGrassdoor ? 'FILTER AND SORT' : 'Filters'}
                          </span>

                          {filterApplied && <span className="filter-indicator" />}
                        </div>
                      ) : null}
                    </div>

                    <div className="four-rem-mb four-rem-pb zipps-see-all">
                      {currentCategory?.products ? (
                        <div>
                          <h4 className="bold a-category-name bold one-rem-mt mb-0">
                            {currentCategory.category_name}
                          </h4>

                          <h6 className="description">{currentCategory.category_description}</h6>

                          {currentCategory?.category_offer_description && (
                            <em>
                              <div className="mini-description mt-1 !text-[12px] !mt-[12px]">
                                {currentCategory.category_offer_description}
                              </div>
                            </em>
                          )}

                          {currentCategory?.category_sale_description && (
                            <em>
                              <div className="mini-description mt-1">
                                {currentCategory.category_sale_description}
                              </div>
                            </em>
                          )}


                          {/* {renderProducts(currentCategory, tab, currentCategory.category_name)} */}
                          <RenderProducts productDetails={currentCategory} currentTab={tab == SCHEDULE ? 'Schedule' : 'ASAP'} />
                          {/* </div> */}
                        </div>
                      ) : (
                        <>
                          {!fetching && (
                            <div className="one-rem-mt four-rem-mb">
                              {/* <ItemNotFound text="No products found" /> */}
                              <NoProductAvailable
                                currentTab={tab}
                                asapProductCount={asapCount}
                                scheduleProductCount={scheduleCount}
                                setTab={setTab}
                                asapEnabled={asapEnabled}
                                scheduleEnabled={scheduleEnabled}
                                applyFilters={filters => {
                                  setListLoading(true);
                                  if (!filters) {
                                    // toggleFilterPopup(false);
                                    setFilters(filterList);
                                  } else {
                                    setFilters(filters);
                                  }
                                  if (!isLoading) setListLoading(false);
                                }}
                              />
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>

                </div >
              </div >
            </div >
            {
              ALLOW_PRODUCT_COMPARE && compare?.productList?.length ? (
                <FloatingCompareButton
                  isSolid={isSolid}
                  products={compare?.productList || []}
                  handleOnClick={() => {
                    handleFloatingButtonClick();
                  }}
                />) : null}
          </div >
          {isNewHomePageApplicable ? (
            <ScrollToTop />
          ) : null}

          <button
            onClick={() => toggleFilterPopup(true)}
            className={`scroll-to-top filter`}
          >
            <span className="icon icon-filter-dark-i text-[12px]" />
          </button>
          {isNewHomePageApplicable && false ? <FixedBottomBar
            scrollDirectionTop={false}
            tab={tab}
            setTab={setTab}
            hideFreightLimit={hideFreightLimit}
            unifiedMenu={unifiedMenu}
            displayFreightBanner={displayFreightBanner}
            asapEnabled={asapEnabled}
            scheduleEnabled={scheduleEnabled}
            asapProductsCount={asapCount}
            scheduledProductsCount={scheduleCount}
            // hideFilters={hideFilters}
            filters={filters}
            toggleFilterPopup={toggleFilterPopup}
            filterApplied={filterApplied}
            setDisplayFreightBanner={setDisplayFreightBanner}
          /> : null}
          {/* <div className={`fixed-bottom-bar d-lg-none ${!scrollDirectionTop ? "not-at-top" : ""}`}>
            {tab == ASAP ? <DeliveryTiming currentTab={tab} setTab={setTab} /> : <DeliveryTimingSchedule />}
            {hideFreightLimit || (!appConfig.isGrassdoor) ? null :
              displayFreightBanner
                ?
                <FreightMessageBanner currentTab={tab} initialDeliveryAddressDetails={false} dismiss={() => setDisplayFreightBanner(false)} />
                : null
            }
            <div className={`bottom-tab `}>
              <DeliveryTypeToggle
                currentTab={tab}
                setTab={setTab}
                isAsapDisabled={false}
                isScheduleDisabled={false}
                className="aditya"
                asapProductsCount={asapCount}
                scheduledProductsCount={scheduleCount}
              />
              {
                !renderHideFiltersArray() ? <FloatingFilterButton
                  filters={filters}
                  toggleFilterPopup={toggleFilterPopup}
                  filterApplied={filterApplied}
                  isSolid={true}
                /> : null
              }
            </div>
          </div> */}

          <CSSTransition appear in={isFilterPopupVisible} classNames="slideup-wrapper" mountOnEnter timeout={300} unmountOnExit>
            <Filters
              isFilterPopupVisible={isFilterPopupVisible}
              filterList={filters}
              applyFilters={handleApplyFilters}
              cancelFilters={() => toggleFilterPopup(false)}
              deviceType="mobile"
              hideFilters={[]}
              isPopup
              asapProductsCount={asapCount}
              scheduledProductsCount={scheduleCount}
              isFilterApplied={filterApplied}
              currentTab={tab}
            />
          </CSSTransition>
        </div >
      </div >

      {/* {headerText ? (
        <DescriptiveText
          header={headerText || undefined}
          asapDescription={descriptionText}
          scheduleDescription={descriptionText}
          shopPage
          tab={tab}
        />
      ) : null} */}
    </>
  );
};

const RenderProducts = React.memo(({ productDetails, currentTab }) => {

  if (productDetails && productDetails.products) {
    return (
      <div className={`v-list product-category mt-2 deals-section-products`}>
        {productDetails.products.map((item, productIndex) => {
          return (
            <Product
              page={`${currentTab == SCHEDULE ? 'Schedule' : 'ASAP'} List-${productDetails.category_name}`}
              productIndex={productIndex}
              categoryIndex={0}
              width50
              data={item}
              openInPopup
              source={SegmentSource.shopPage}
            />
          );
        })}
      </div>
    )
  }
  return null;
});

RenderProducts.displayName = 'RenderProducts';

const { shopRedirects: redirects } = grassdoorRedirects;

const getServerSidePropsTest = async ({ req, res, query }) => {
  const { slug, tab } = query;

  if (tab !== 'asap' && tab !== 'schedule' && tab !== undefined) {
    return {
      redirect: {
        destination: `/shop/${slug}?tab=asap`,
        permanent: false,
      },
    };
  }

  const redirectUrl = redirects[slug];

  if (process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR && redirectUrl) {
    res.writeHead(301, { location: redirectUrl });
    res.end();
    return { props: {} };
  }
  const cookies = new Cookies(req, res);
  const token = cookies.get(COOKIE_VARIABLES.token) || '';
  const zipcode = cookies.get(COOKIE_VARIABLES.zipcode) || DEFAULT_ZIPCODE;
  const placeId = cookies.get(COOKIE_VARIABLES.placeId) || '';
  const latitude = cookies.get(COOKIE_VARIABLES.latitude) || DEFAULT_LOCATION.lat;
  const longitude = cookies.get(COOKIE_VARIABLES.longitude) || DEFAULT_LOCATION.lng;
  const host = req?.headers?.host === 'localhost:3000'
    ? process.env.NEXT_PUBLIC_FALLBACK_API_URL
    : req?.headers?.host;
  const authorizationToken = token ? { authorization: `Bearer ${token}` } : {};

  const urlBase = process.env.NEXT_PUBLIC_SECURE_EC2_URL;
  const asapBundleSlug = 'asapBundleSlug';


  const headers = { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, ...authorizationToken, 'saas-domain': host };

  const deliveryResponse = await fetchServerResponse({
    url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/pre_fetch/delivery_details/${zipcode}`,
    method: 'GET',
    headers,
  });
  const { asap_driver_id } = deliveryResponse.data || {};

  let urlASAP = slug === asapBundleSlug
    ? `${urlBase}/products/bundle/${zipcode}`
    : `${urlBase}/categories/${slug}/${zipcode}`;

  let urlSchedule = slug === asapBundleSlug
    ? `${urlBase}/products/bundle/${zipcode}`
    : `${urlBase}/products/schedule/${slug}/${zipcode}`;

  if (process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR || process.env.NEXT_PUBLIC_DEFAULT_SITES) {
    urlASAP += `?sort_key=deals_first&order=asc${asap_driver_id ? `&asap_driver_id=${asap_driver_id}` : ``}`;
    urlSchedule += '?sort_key=deals_first&order=asc';
  }

  const requestWithLogging = async (url, headers) => {
    try {
      return await axios.get(url, { headers });
    } catch (error) {
      console.error(`Failed to fetch data from ${url}`, error);
      return null;
    }
  };

  const promiseArray = [
    requestWithLogging(urlASAP, { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host, }),
    requestWithLogging(urlSchedule, { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host, }),
    requestWithLogging(`${urlBase}/cms/carousel_details`, { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host, }),
    requestWithLogging(`${urlBase}/pre_fetch/delivery_details/${zipcode}`, { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host, }),
    requestWithLogging(`${urlBase}/categories/all_categories/'90001'?shop_slug=${slug}`, { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host, }),
    requestWithLogging(`${urlBase}/pre_fetch/logo`, { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host, }),
  ];

  const [
    asapResponse,
    scheduleResponse,
    bannerResponse,
    deliverDetailsResponse,
    filterResponse,
    fullCategoriesListResponse,
  ] = await Promise.all(promiseArray);

  const asapData = asapResponse ? categoriesHelper(asapResponse.data.categories || []) : [];
  const scheduleData = scheduleResponse ? categoriesHelper(scheduleResponse.data.categories || []) : [];

  const tempAsapProductsCategoryInitial = asapData.length ? asapData[0] : {};
  const tempScheduleProductsCategoryInitial = scheduleData.length ? scheduleData[0] : {};

  const asapProductsCategoryInitial = { ...tempAsapProductsCategoryInitial, products: tempAsapProductsCategoryInitial.products || [] };
  const scheduleProductsCategoryInitial = { ...tempScheduleProductsCategoryInitial, products: tempScheduleProductsCategoryInitial.products || [] };

  const asapCount = slug === asapBundleSlug ? asapResponse?.data.count : asapResponse?.data.asap_product_count || 0;
  const scheduleCount = scheduleResponse?.data.schedule_product_count || 0;

  const bannerData = bannerResponse?.data.data?.banner_images || {};
  const fullCategoriesList = fullCategoriesListResponse?.data || [];

  const productStrainTypes = filterResponse ? categoriesHelper(filterResponse.data.product_strain_types || []) : [];
  const brands = filterResponse ? categoriesHelper(filterResponse.data.brands || []) : [];
  const deviceTypes = filterResponse?.data.device_types || [];
  const filterList = generateFilters({ productStrainTypes, brands, deviceTypes });

  return {
    props: {
      asapProductsCategoryInitial,
      scheduleProductsCategoryInitial,
      filterList,
      bannerData,
      noIndex: false,
      asapCount,
      scheduleCount,
      asapProductsCategoryDetails: asapResponse?.data.categoryDetails || {},
      scheduleProductsCategoryDetails: scheduleResponse?.data.categoryDetails || {},
      id: String(slug),
      key: String(slug),
      fullCategoriesList,
    },
  };
};

export const getServerSideProps = withConfig(getServerSidePropsTest)
export default pageDisable(ViewAllProducts);
